import "../chunk-D57E6H3M.mjs";

// src/hooks/useNow.ts
import { useEffect, useState } from "react";
function msUntilMidnight(from) {
  const midnight = new Date(from.getFullYear(), from.getMonth(), from.getDate() + 1);
  return midnight.getTime() - from.getTime();
}
function sameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
function useNow() {
  const [now, setNow] = useState(() => /* @__PURE__ */ new Date());
  useEffect(() => {
    const timer = setTimeout(() => setNow(/* @__PURE__ */ new Date()), msUntilMidnight(now) + 1e3);
    const renew = () => setNow((current) => {
      const next = /* @__PURE__ */ new Date();
      return sameDay(current, next) ? current : next;
    });
    document.addEventListener("visibilitychange", renew);
    window.addEventListener("focus", renew);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", renew);
      window.removeEventListener("focus", renew);
    };
  }, [now]);
  return now;
}
export {
  useNow
};
//# sourceMappingURL=useNow.mjs.map